<app-widget-asset-preview [asset]="getAsset(key)" (selectFiles)="onFilesSelected($event)" [editable]="true" [dataTestId]="'featured-asset'">
</app-widget-asset-preview>